import { mapState } from "vuex";
import MixpanelEvents from "@/constants/events";

import {
  GET_CALENDAR_DATA,
} from "@/store/calendar/actions";

import {
  CALENDAR_INIT_SETTINGS,
  CALENDAR_STORE_SETTINGS,
  CALENDAR_CHANGE_SETTINGS,
  CALENDAR_REMOVE_SETTINGS,
  CALENDAR_UPDATE_SETTINGS,
  CALENDAR_ACTIVATE_SETTINGS,
} from "@/store/calendar-settings/actions";

import apiSettingsKeys from "@/store/calendar-settings/interfaces/api-keys";
import presets from "@/store/calendar-settings/interfaces/presets";

export default {
  data() {
    return {
      settingsTitle: null,
    }
  },
  props: {
    isReservationCalendar: {
      type: Boolean,
      required: false,
      default: null,
    },
    isRatesCalendar: {
      type: Boolean,
      required: false,
      default: null,
    }
  },
  methods: {
    async getData(options) {
      options = options || {};

      await this.$store.dispatch(GET_CALENDAR_DATA, {
        property_ids: this.propertyIds,
        ...options,
        ...this.filters,
      });
    },
    async initSettings() {
      await this.$store.dispatch(CALENDAR_INIT_SETTINGS);
    },
    async chooseSettings(title) {
      await this.$store.dispatch(CALENDAR_ACTIVATE_SETTINGS, title);
      this.$monitorService.track(MixpanelEvents.CALENDAR_PRESET_VIEW_CHOOSED, {
        title: title
      });
      await this.getData();
    },
    async removeSettings(title) {
      await this.$store.dispatch(CALENDAR_REMOVE_SETTINGS, title);
      await this.getData();
    },
    async storeSettings() {
      if (!this.settingsTitle) {
        await this.$store.dispatch(CALENDAR_UPDATE_SETTINGS, this.filters);
        this.$monitorService.track(MixpanelEvents.CALENDAR_PRESET_VIEW_SAVED);
        return;
      }

      await this.$store.dispatch(CALENDAR_STORE_SETTINGS, this.settingsTitle);

      this.settingsTitle = null;
    },
    async changeSettings(key) {
      await this.$store.dispatch(CALENDAR_CHANGE_SETTINGS, this.filters);
      this.$monitorService.track(MixpanelEvents.CALENDAR_PRESET_VIEW_CHANGED, {
        key: key
      });

      if (apiSettingsKeys.indexOf(key) > -1) {
        await this.getData();
      }
    },
    async setPreset() {
      if (this.isReservationCalendar) {
        await this.$store.dispatch(CALENDAR_CHANGE_SETTINGS, presets.reservationCalendar);

        return;
      }

      if (this.isRatesCalendar) {
        await this.$store.dispatch(CALENDAR_CHANGE_SETTINGS, presets.ratesCalendar);
      }
    },
  },
  computed: {
    filters: {
      get() {
        return this.settings;
      },
      set() {}
    },
    ...mapState({
      settings: state => state.calendarSettings.current,
      storedSettings: state => state.calendarSettings.stored,
    }),
  },
}
